module.exports = __webpack_public_path__ + "img/como_lo_hacemos_link.b2dc0cda.png";